import {
  SoftSecondaryButton,
  type SoftSecondaryButtonProps,
} from "./SoftSecondaryButton";

export type DialogSecondaryButtonProps = SoftSecondaryButtonProps;

/** @deprecated Use SoftSecondaryButton. */
export const DialogSecondaryButton = SoftSecondaryButton;
